var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz_term"},[(_vm.limited_flag === 1)?_c('span',[_vm._v("公開終了 "+_vm._s(_vm.dateTime))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }